/**
 * AppIcon — square icon-only brand mark for larger placements
 * (empty state hero, share cards, mobile splash, admin brand mark).
 * Uses the official SerpNex "SN" app icon asset.
 */
const APP_ICON = "https://customer-assets-lxgj4vgw.emergentagent.net/job_serpnex-stage/artifacts/kgfaak1p_serpnex%20app%20icon.jpeg";

export default function AppIcon({ size = 64, className = "", rounded = "rounded-2xl" }) {
  return (
    <div
      role="img"
      aria-label="SerpNex"
      data-testid="app-icon"
      className={`${rounded} shrink-0 ${className}`}
      style={{
        width: size,
        height: size,
        backgroundImage: `url("${APP_ICON}")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        filter: "brightness(1.15) contrast(1.35) saturate(1.05)",
        boxShadow: "0 4px 14px rgba(10,13,20,0.08), 0 1px 2px rgba(10,13,20,0.04)",
      }}
    />
  );
}
